import { render, staticRenderFns } from "./_Completed.vue?vue&type=template&id=2667ad04&scoped=true&"
import script from "./_Completed.vue?vue&type=script&lang=js&"
export * from "./_Completed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2667ad04",
  null
  
)

export default component.exports